import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Field, btnPrimary, inputCls } from "./ui";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export function ChangePassword() {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const mismatch = f.confirm && f.confirm !== f.new_password;
  const submit = async (e) => {
    e.preventDefault();
    if (mismatch) return;
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Palavra-passe alterada. As outras sessões foram terminadas.");
      setF(EMPTY);
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="bo-card grid gap-4 p-5 sm:grid-cols-3" data-testid="change-password-form">
      <h2 className="flex items-center gap-2 font-bold sm:col-span-3"><KeyRound className="h-4 w-4" />Alterar palavra-passe</h2>
      <Field label="Palavra-passe atual"><input type="password" required autoComplete="current-password" value={f.current_password} onChange={set("current_password")} className={inputCls} data-testid="change-password-current-input" /></Field>
      <Field label="Nova palavra-passe"><input type="password" required minLength={8} autoComplete="new-password" value={f.new_password} onChange={set("new_password")} className={inputCls} data-testid="change-password-new-input" /></Field>
      <Field label="Confirmar nova palavra-passe"><input type="password" required autoComplete="new-password" value={f.confirm} onChange={set("confirm")} className={inputCls} data-testid="change-password-confirm-input" /></Field>
      <p className="text-xs text-gray-500 sm:col-span-3">Mínimo 8 caracteres, com letras e números.{mismatch && <span className="ml-2 text-red-600" data-testid="change-password-mismatch">As palavras-passe não coincidem.</span>}</p>
      <button disabled={busy || mismatch} className={`${btnPrimary} w-fit`} data-testid="change-password-submit-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />}Alterar palavra-passe</button>
    </form>
  );
}
